import { FETCH_ACTIVITY_LOGS } from "../../actions/actionTypes";

const initialState = {
   activitylog:[],
   loading:false
};

const reducer = (state=initialState, action)=>{
    switch(action.type){
        case FETCH_ACTIVITY_LOGS.REQUEST:
            return { ...state, activitylog: [], loading: true };
        case FETCH_ACTIVITY_LOGS.FAILURE:
            return { ...state, activitylog: [], loading: false };
        case FETCH_ACTIVITY_LOGS.SUCCESS:
            return {...state,activitylog: action.data,loading: false};
        default:
            return state
    }
}

export default reducer;